import "bootstrap/dist/css/bootstrap.min.css";
import {
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  Tooltip,
} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";
import { FaWrench } from "react-icons/fa6";

// Register chart elements
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
  ChartDataLabels
);

const MaintenanceCostOverview = ({ maintenanceCost }) => {
  const [labels, setLabels] = useState([]);
  const [dataValues, setDataValues] = useState([]);

  // populate labels and data from maintenanceCost prop
  useEffect(() => {
    if (Array.isArray(maintenanceCost) && maintenanceCost.length) {
      setLabels(maintenanceCost.map(item => item.category?.title || `Category ${item.service_category_id}`));
      setDataValues(maintenanceCost.map(item => Number(item.total_cost || 0)));
    } else {
      setLabels([]);
      setDataValues([]);
    }
  }, [maintenanceCost]);

  const chartData = {
    labels,
    datasets: [
      {
        label: "Total Cost (₨)",
        data: dataValues,
        backgroundColor: "#38bdf8",
        hoverBackgroundColor: "#0ea5e9",
        borderRadius: 6,
        barThickness: 40,
        categoryPercentage: 0.6,
        barPercentage: 0.8,
      },
    ],
  };

  const options = {
    maintainAspectRatio: false,
    responsive: true,
    layout: {
      padding: {
        top: 30, // ⬅️ Key fix: Prevents label from getting cut
      },
    },
    plugins: {
      legend: { display: false },
      datalabels: {
        anchor: "end",
        align: "end",
        color: "#4F19E2",
        font: { weight: "bold", size: 9 },
        formatter: (value) => `Rs ${value.toLocaleString()}`,
      },
      tooltip: {
        callbacks: {
          label: (context) => `Rs ${Number(context.raw).toLocaleString()}`,
        },
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          callback: function (value) {
            return "Rs " + value.toLocaleString();
          },
        },
        grid: { drawTicks: true },
        title: {
          display: true,
          text: "Cost (₨)",
        },
      },
      x: {
        ticks: {
          autoSkip: false,
          callback: function (val) {
            const label = this.getLabelForValue(val);
            return label.length > 20 ? label.slice(0, 20) + "..." : label;
          },
        },
        title: {
          display: true,
          text: "Maintenance Category",
        },
      },
    },
  };

  // Dynamic width: 80px per label
  const dynamicWidth = `${labels.length * 80}px`;

  return (
    <div className="card_container">
      <h5 className="mb-3 scheduled_unscheduled_heading">
        <FaWrench color="#4F19E2" />
        Maintenance Cost Overview
      </h5>

      <hr />
      <div className="overflow-auto">
        <div
          style={{
            width: dynamicWidth,
            height: "400px",
          }}
        >
          <Bar data={chartData} options={options} plugins={[ChartDataLabels]} />
        </div>
      </div>
    </div>
  );
};

export default MaintenanceCostOverview;
